import { useMemo, useState } from "react";
import { AxiosError } from "axios";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { IVinculoMarketplaceProduto } from "../interfaces/IVinculoMarketplaceProduto";

export const useVinculosMarketplace = () => {
    const [loading, setLoading] = useState(false);
    const showSnackbar = useSnackbar();
    const apiProdutos = useMemo(() => ApiFactory.getApi("MS_PRODUTOS"), []);

    const listarVinculos = async (
        tipo: string = "IFOOD",
        marketplaceUuid?: string
    ): Promise<IVinculoMarketplaceProduto[]> => {
        try {
            const params: Record<string, string> = { tipo };
            if(marketplaceUuid) {
                params.marketplaceUuid = marketplaceUuid;
            }

            const { data } = await apiProdutos.get(`/vinculos-marketplace`, { params });
            return data ?? [];
        } catch (error) {
            console.log(error)
            showSnackbar("Ocorreu um erro ao carregar os vínculos de produtos", { severity: "error" });
            return [];
        }
    };

    const salvarVinculo = async (
        vinculo: IVinculoMarketplaceProduto
    ): Promise<IVinculoMarketplaceProduto | null> => {
        setLoading(true);

        try {
            const { data } = await apiProdutos.put(`/vinculos-marketplace`, vinculo);
            showSnackbar("Produto vinculado com sucesso", { severity: "success" });
            return data?.vinculo ?? null;
        } catch (error) {
            if(error instanceof AxiosError) {
                showSnackbar(error.response?.data?.message ?? "Erro ao vincular o produto", { severity: "error" });
                return null;
            }

            showSnackbar("Ocorreu um erro ao vincular o produto", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    };

    const excluirVinculo = async (uuid: string): Promise<boolean> => {
        setLoading(true);

        try {
            await apiProdutos.delete(`/vinculos-marketplace/${uuid}`);
            showSnackbar("Vínculo removido", { severity: "success" });
            return true;
        } catch (error) {
            showSnackbar("Ocorreu um erro ao remover o vínculo", { severity: "error" });
            return false;
        } finally {
            setLoading(false);
        }
    };

    return { loading, listarVinculos, salvarVinculo, excluirVinculo };
};
